var React = require('react');

// Style
require('./VideoMembershipOverlay.scss');

var { getLoginStatus } = require('Logon/Logon');

class VideoMembershipOverlay extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoggedIn: false,
		}
	}

	componentDidMount() {
		getLoginStatus()
			.then(result => {
				this.setState({ isLoggedIn: result.isLoggedIn });
			})
			.catch(err => {
				console.error('Login status fetch failed:', err);
			});
	}
	
	render() {
		const { membershipTier, children } = this.props;

		let message = null;
		switch (membershipTier) {
			case 'Premium':
				message = 'Premium';
				break;
			case 'Member':
				if (this.state.isLoggedIn === false) {
					message = 'Sign-in';
				}
				break;
			default:
				return children;
		}
		if (message === null) {
			return children;
		}

		return (
			<div className='c-video-membership-overlay'>
				<div className={`c-video-membership-overlay__message c-video-membership-overlay__message--${message.toLowerCase()}`}>
					{message}
				</div>
				{children}
			</div>
		);
	}
}

module.exports = VideoMembershipOverlay;



// WEBPACK FOOTER //
// ./src/common/VideoMembershipOverlay/VideoMembershipOverlay.js